import { MENU_SECTION } from './constants'

const menu = [
  { id: 1, name: 'home', display: 'label.home', icon: 'mdi-home', section: MENU_SECTION.USER },
  { id: 2, name: 'ediReleases', display: 'label.releases', icon: 'mdi-view-dashboard', section: MENU_SECTION.USER },
  { id: 3, name: 'ediShipNewCapture', display: 'label.newCapture', icon: 'mdi-text-box-plus-outline', section: MENU_SECTION.SHIPMENTS },
  { id: 4, name: 'ediShipPendings', display: 'label.pendingShipments', icon: 'mdi-text-box-multiple-outline', section: MENU_SECTION.SHIPMENTS },
  { id: 5, name: 'ediInvoices', display: 'label.invoices', icon: 'mdi-file-document', section: MENU_SECTION.USER },
  { id: 6, name: 'consignment', display: 'label.Consignment', icon: 'mdi-text-box-plus-outline', section: MENU_SECTION.USER }
]

export default {
  getUserSection () {
    return menu.filter(m => m.section === MENU_SECTION.USER)
  },
  getShipmentSection () {
    return menu.filter(m => m.section === MENU_SECTION.SHIPMENTS)
  },
  getAllSections () {
    return menu
  }
}
